<template>
    <div style="padding:10px 0px 0 20px;">
        <SearchList v-model="params" :queryConfig="queryConfig" @query="getList"></SearchList>
        <div class="box-tab-wrap weblist_wrap">
            <div class="table_wrap tab-over-ellipsis weblist_wrap" style="padding:0">
                <vxe-table v-loading="loading" :data="list" border show-header-overflow
                    show-overflow highlight-hover-row height="auto" auto-resize stripe round
                    resizable style="height:56vh;">
                    <vxe-table-column title="企业名称" field="comName"></vxe-table-column>
                    <vxe-table-column title="统一信用代码" field="organizationCode"></vxe-table-column>
                    <vxe-table-column title="企业联系人" field="comContact"></vxe-table-column>
                    <vxe-table-column title="联系手机号" field="comContactPhone"></vxe-table-column>
                    <vxe-table-column title="操作" align="center" width="120px">
                        <template slot-scope="{ row , $index}">
                            <div class="flex curd-btn-wrap">
                                <el-link @click="sure(row,$index)" :underline="false"
                                    type="success">选择
                                </el-link>
                            </div>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
            <div class="footer_wrap">
                <pager :params="params" :total="total" @getData="getList"></pager>
            </div>
        </div>
    </div>
</template>
<script>
import tabTpl from "@/mixins/tabTpl.js";
import {
  querySysComByTypePageReq
} from "@/api/base";

export default {
  name: "sysCompany",
  mixins: [tabTpl],
  props: {
    comType: {//企业类型
      type: Number,
      default: -1
    }
  },

  methods: {
    sure(item, idx) {
      this.$emit("handle", item)
    },
    getList() {
      this.loading = true;

      var params = {
        ...this.params
      };

      this.queryConfig.forEach(item => {
        if (typeof item.format == "function") {
          item.format(params, params[item.key]);
        }
      });
      if (this.comType != -1) {
        params.comType = this.comType;
      }
      querySysComByTypePageReq(params).then(res => {
        this.loading = false;

        this.tabList = res.data;
        this.list = res.data;
        this.total = res.total || 0;



      });
    },

  },
  data() {
    return {

      loading: false,
      activeName: "Wait",
      tabList: [],
      queryConfig: [{
        label: "企业名称",
        key: "comName",
        value: "",
      }, {
        label: "统一信用代码",
        key: "organizationCode",
        value: "",
        queryLabelWidth:"100"
      }]
    };
  }
};

</script>
